import * as React from 'react';
import classnames from 'classnames';

const CustomOptions: React.SFC<any> = ({
    label,
    data,
    isSelected,
    isFocused,
    isDisabled,
    selectOption,
    ...props
}) => {
    return (
        <div
            {...props.innerProps}
            onClick={() => selectOption(data)}
            className={classnames('react-select__custom-option', {
                'option--selected': isSelected,
                'option--focused': isFocused,
                'option--disabled': isDisabled
            })}
        >
            <span className="img-box">
                <img src={data.image} />
            </span>{' '}
            <span>{label}</span>
        </div>
    );
};
export default CustomOptions;
